export const fileUploadHeaders = {
  'Content-Type': 'multipart/form-data'
};
